// Juni 2026 · Same-Site-Fix für API-Aufrufe.
// Zeigt REACT_APP_BACKEND_URL auf die Domain OHNE www, die Seite läuft aber auf
// www (oder umgekehrt), dann sind alle POST/PUT-Aufrufe cross-origin. Der
// Redirect apex→www beim CORS-Preflight bricht ab → im Browser nur
// „Network Error" (GETs funktionieren, weil sie ohne Preflight umgeleitet
// werden). Deshalb werden solche Aufrufe auf die aktuelle Origin umgeschrieben.
import axios from 'axios';

const configured = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const bareHost = (host) => host.replace(/^www\./i, '').toLowerCase();

export function initApiOrigin() {
  if (!configured || typeof window === 'undefined') return;
  let cfg;
  try {
    cfg = new URL(configured);
  } catch {
    return;
  }
  const here = window.location.host;
  if (cfg.host === here) return;
  if (bareHost(cfg.host) !== bareHost(here)) return; // echte Fremd-Domain → unverändert

  const rewrite = (url) =>
    typeof url === 'string' && url.startsWith(configured)
      ? window.location.origin + url.slice(configured.length)
      : url;

  axios.interceptors.request.use((config) => {
    config.url = rewrite(config.url);
    if (config.baseURL) config.baseURL = rewrite(config.baseURL);
    return config;
  });

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) =>
    originalFetch(typeof input === 'string' ? rewrite(input) : input, init);
}
